import EventEmitter from './EventEmitter.js';
import Events from './Events.js';

export default class PointerCoordinates {
    constructor(domElement) {
        this.domElement = domElement;
        this.eventEmitter = new EventEmitter();
        this.coordinates = { x: 0, y: 0 };

        this.domElement.addEventListener(
            'mousemove',
            (event) => this.updateCoordinates(event),
            false
        );
        this.domElement.addEventListener(
            'touchmove',
            (event) => this.updateCoordinates(event),
            false
        );
        this.domElement.addEventListener(
            'touchstart',
            (event) => this.updateCoordinates(event),
            false
        );

        this.eventEmitter.on(Events.RESIZE, this, (event) =>
            this.updateCoordinates(event)
        );
    }

    updateCoordinates(event) {
        const rect = this.domElement.getBoundingClientRect();
        const screenX = event.touches
            ? event.touches[0].clientX
            : event.clientX;
        const screenY = event.touches
            ? event.touches[0].clientY
            : event.clientY;
        this.coordinates.x = ((screenX - rect.left) / rect.width) * 2 - 1;
        this.coordinates.y = -((screenY - rect.top) / rect.height) * 2 + 1;
    }
}
